import type {CopilotMarkdownExtension} from '@github-ui/copilot-markdown/extension'

import {type NodeMeta, YamlBlockExtension} from '../../yaml-block-extension'
import {IssueTreeBlock, type IssueTreeBlockProps} from './IssueTreeBlock'

const instance = new (class extends YamlBlockExtension<IssueTreeBlockProps> {
  override get dataAttribute(): `data-${string}` {
    return 'data-tree-issue-block'
  }

  override isSupported(node: NodeMeta): boolean {
    return node.lang === 'yaml' && node.type === 'issue-tree'
  }

  override extractProps(node: NodeMeta): IssueTreeBlockProps {
    return {
      data: node.value,
    }
  }

  override createComponent(props: IssueTreeBlockProps): React.ReactNode {
    return <IssueTreeBlock {...props} />
  }
})()

export default function issueTreeExtension(): CopilotMarkdownExtension {
  return instance
}
